'use client'
import ErrorHandler from '@/components/ErrorHandler'


export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {

  return (
    <ErrorHandler reset={reset} error={error}></ErrorHandler>
  )
}